// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f1ca65{text-align:center;font-size:calc(1em + var(--scale)*.25em)}.c54acd{margin:1em 0 var(--spacer)}", ""]);
// Exports
exports.locals = {
	"day": "f1ca65",
	"calendar": "c54acd"
};
module.exports = exports;
